module.exports = __webpack_public_path__ + "img/ceo-headshot-mobile.a2dcb6b9.png";